/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
import { o_util } from "../common/namespaces";

import type { GlobalUtils } from "./index.js";

/**
 *
 */
export type Event = GlobalUtils["event"];

export type { Unset } from "../lib/event/head.js";

/**
 *
 */
export const event: Event = o_util.event;

/**
 *
 *
 *
 */
export const delegate: Event["delegate"] = event.delegate;

/**
 *
 *
 *
 */
export const stop: Event["stop"] = event.stop;

/**
 *
 *
 *
 */
export const undelegate: Event["undelegate"] = event.undelegate;

/**
 *
 *
 *
 */
export const on: Event["on"] = event.on;

/**
 *
 *
 *
 */
export const withEvents: Event["withEvents"] = event.withEvents;

/**
 *
 *
 *
 */
export const unsetAll: Event["unsetAll"] = event.unsetAll;

/**
 *
 *
 *
 */
export const whichTransitionEndEvent: Event["whichTransitionEndEvent"] =
  event.whichTransitionEndEvent;
